<!-- <div *ngIf="dataSource.data.length > 0; else noOffers"> -->

<div class="page-container h-100" *ngIf="offerDetails" #content>
  <mat-sidenav-container class="d-flex h-100">
    <mat-sidenav-content class="d-flex flex-column align-items-center w-100 hidden-overflow">
      <mat-toolbar class="cdc-header">
        <div class="d-flex flex-row  gap-2">
          <span [routerLink]="['/admin/offers']" class="editable-title">{{ 'Offers' | translate }}</span> >
          <span>{{ offerDetails!.name }}</span>
        </div>

        <div class="d-flex flex-row align-items-center gap-2">
          <button mat-stroked-button class="cdc-button" [ngClass]="{'disabled':this.availablePages.length <= 0}" (click)="availablePages.length > 0 && onAssociatePage()"><mat-icon>add</mat-icon>{{ 'Associate Page' | translate }}</button>
          <button mat-stroked-button class="cdc-button" matTooltip="{{ 'More' | translate }}" [matMenuTriggerFor]="morePage">
            <mat-icon class="m-0">more_vert</mat-icon>
          </button>
          <mat-menu class="more-menu" #morePage="matMenu" xPosition="before">
            <button class="more-menu-item" mat-menu-item (click)="rightSidenav.toggle(true)">
              <mat-icon>settings</mat-icon>
              <span>{{'Settings' | translate}}</span>
            </button>
            <button class="more-menu-item" mat-menu-item (click)="onCreateOfferForCustomer()">
              <mat-icon>request_quote</mat-icon>
              <span>{{'Generate offer' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </mat-toolbar>
      <div class="d-flex justify-content-end align-items-center w-100"></div>

      <div class="list-btn">
        <div class="offer-pages-content">
          <div class="offer-pages-sub-content mat-elevation-z8 col-11 col-lg-11 col-md-11 m-3">
            <table mat-table matSort [dataSource]="dataSource">

              <!-- Page Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{ 'Page Name' | translate }} </th>
                <td #pageTitle mat-cell *matCellDef="let page" class="ellipsis-cell" tooltipTruncate [matTooltip]="(page.parentPage !== null && page.parentPage !== undefined ? page.parentPage.title + ' > ' : '') + page.title!"> {{ page.parentPage !== null && page.parentPage !== undefined ? page.parentPage.title + " > ": "" }}{{ page.title }} </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> {{ 'Type' | translate }} </th>
                <td #pageType mat-cell *matCellDef="let page"> {{ PageType[page.type] | translate }}</td>
              </ng-container>
              <!-- Order Column -->
              <ng-container matColumnDef="order">
                <th mat-header-cell *matHeaderCellDef> {{ 'Order' | translate }} </th>
                <td #pageOrder mat-cell *matCellDef="let page"> {{ page.type === PageType.CUSTOMER ? page.order : '' }}</td>
              </ng-container>
              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let page">
                  <button mat-icon-button (click)="deleteOfferPage($event, page)" matTooltip="{{ 'Delete' | translate }}">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr class="table-row" mat-row *matRowDef="let page; columns: displayedColumns" (click)="navigateToPage(page)"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
              </tr>
            </table>
            <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
          </div>
        </div>
        <div class="expand-btn-div">
          <button (click)="rightSidenav.toggle()" matTooltip="{{ 'Settings' | translate }}"
                  class="expand-button-left">
            <mat-icon class="settings-icon">menu</mat-icon>
          </button>
        </div>
      </div>


    </mat-sidenav-content>
    <mat-sidenav #rightSidenav mode="side" position="end" class="main-content offer-side-nav" opened>

      <!-- offer settings -->
      <div class="offer-settings">
        <button mat-button class="cdc-button active offer-settings-title">
          <span>{{"Offer" | translate}}</span>
        </button>

        <mat-nav-list class="cdc-list">
          <!-- general -->
          <div class="cdc-form-field actif">
            <div class="cdc-label">
              {{ "Title" | translate }}
            </div>

            <input matInput type="text" [(ngModel)]="offerDetails!.name">
          </div>
          <div class="cdc-form-field actif" [ngClass]="{'error': offerDetails!.code.length <= 0 || codeExists}">
            <div class="cdc-label">
              {{ "Code" | translate }}
            </div>

            <mat-form-field class="select-container select-chips w-100">
              <mat-chip-grid #codesList>

                <mat-chip *ngFor="let code of offerDetails!.code" (removed)="onRemoveCode(code)">
                  {{ code }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>

                <input [matChipInputFor]="codesList" class="chip-input-multiple" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="onAddCode($event)" (input)="onInputChange($event)" autocomplete="off" />
              </mat-chip-grid>
            </mat-form-field>

            <mat-error [ngClass]="{'hidden':offerDetails!.code.length > 0}">{{ 'Cannot be empty.' | translate }}</mat-error>
            <mat-error [ngClass]="{'hidden':!codeExists}">{{ 'The code already exists.' | translate }}</mat-error>
          </div>
          <div class="cdc-form-field actif">
            <div class="cdc-label">
              {{ "Expiration delay" | translate }} ({{ "hours" | translate }})
            </div>

            <input matInput type="number" min="0" step="1" [(ngModel)]="offerDetails!.expirationDelay"
              (keypress)="blockDecimal($event)" (focusout)="normalizeExpirationDelay()">
          </div>
          <div class="cdc-form-field">
            <mat-checkbox [(ngModel)]="offerDetails!.isRequired">
              {{ 'Required' | translate }}
            </mat-checkbox>
          </div>
          <div class="cdc-form-field">
            <mat-checkbox [(ngModel)]="offerDetails!.hidden">
              {{ 'Single route' | translate }}
            </mat-checkbox>
          </div>
        </mat-nav-list>
        <button mat-button class="cdc-button save-offer" [ngClass]="{ 'deactivated': offerDetails!.code.length <= 0 }" (click)="onSaveOffer()" [disabled]="offerDetails!.code.length <= 0">
          <span>{{'Save' | translate}}</span>
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
